import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${({ theme }): string => theme.font_family};
    background-color: ${({ theme }): string => theme.palette_white};
    color: ${({ theme }): string => theme.palette_gray_100};
  }
`;
